<div id="app-frame">
  <nz-spin class="global-spinner" [nzSpinning]="projectQuery.isLoading$ | async" nzSize="large">
    <router-outlet></router-outlet>
  </nz-spin>
</div>
